import { authorizedAxios } from 'config/axios';

export const fetchTenants = () => {
  return authorizedAxios.get('/tenants');
};
